import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-richiesta-di-adesione',
  templateUrl: './richiesta-di-adesione.component.html',
  styleUrls: ['./richiesta-di-adesione.component.css']
})
export class RichiestaDiAdesioneComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  btnRitornaAllaDashboard() {
   // this.router.navigate(['/dashboard/' + iValore], { queryParams: { id: iValore } })
    this.router.navigate(['/dashboard/'])
  }

}
